<template>
  <div class="grid-container">
    <div class="grid-item"/>
    <div class="grid-item"/>
    <div class="grid-item"/>
    <div class="grid-item"/>
    <div class="grid-item">
      <Logo/>
      <p class="logo-text">Acadia Imo</p>
    </div>
    <div class="grid-item"/>
    <div class="grid-item"/>
    <div class="grid-item"/>
    <div class="grid-item"/>
  </div>
</template>

<script>
import Logo from '@/components/Logo';
export default {
  name: 'HelloWorld',
  components: {
    Logo
  },
  props: {
    msg: {
      type: String,
      default: ''
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
h3
  margin 40px 0 0

ul
  list-style-type none
  padding 0

li
  display inline-block
  margin 0 10px

a
  color #42b983
.grid-container, .sub-grid-container
  display grid
  grid-template-columns 1fr 1fr 1fr
  grid-template-rows 100px auto 100px
@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed');
.logo-text
  font-family: 'Roboto Condensed', sans-serif;
  font-size 2rem
</style>
